import * as React from 'react';
import ISubmenu from './ISubmenu';

import * as style from './SubmenuStyle.module.scss'

const Submenu: React.SFC<ISubmenu> = (props) => {
  const { children } = props;

  return (
    <div className={[style.submenu, props.className ? props.className : undefined].join(' ')}>
      {children}
    </div>
  );
};

export default Submenu;
